import { COLOR_OPTIONS } from 'config/style';
import styled from 'styled-components';

interface FlightStageContainerProps {
  backgroundColor: string;
  borderColor: string;
}

export const FlightStageContainer = styled.div<FlightStageContainerProps>`
  background-color: ${props => props.backgroundColor};
  border-bottom: 6px solid ${props => props.borderColor};
  padding: 4px 8px;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 3px;
  overflow: hidden;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  min-width: 0;
`;

export const FlightStageText = styled.div`
  font-weight: 600;
  font-size: 12px;
  line-height: 1.2;
  color: ${COLOR_OPTIONS.NEUTRAL_100};
  text-align: left;
`;

export const FlightRealizationText = styled.div`
  font-weight: 400;
  font-size: 12px;
  line-height: 1.2;
  color: ${COLOR_OPTIONS.NEUTRAL_100};
  text-align: left;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 1;
  min-width: 0;
`;
